import Skeleton from 'react-loading-skeleton';

export const StatusChipLoader = ({ opacity = 0.5 }: { opacity?: number }) => {
  return <Skeleton height={40} style={{ borderRadius: '24px', opacity }} width={168} />;
};
